import { render, staticRenderFns } from "./bigDataPhone.vue?vue&type=template&id=659401b3&scoped=true"
import script from "./bigDataPhone.vue?vue&type=script&lang=js"
export * from "./bigDataPhone.vue?vue&type=script&lang=js"
import style0 from "./bigDataPhone.vue?vue&type=style&index=0&id=659401b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659401b3",
  null
  
)

export default component.exports